/**
 *
 * 中金公司
 *
 */

import { getUrlParam } from '@/utils/api';
import { isBuild } from '@/utils/const';

const comein_channel = 'zjgs';

export const isThirdParty = getUrlParam().comein_channel === comein_channel;

function Bridge() {
	this.title = '中金公司';

	this.comein_channel_pc = 'zjgs';

	this.comein_channel = comein_channel;

	this.authMethod = 1;

	// 以前部分接口需要传zid、后面改成传uc
	this.zid = isBuild ? 20126 : 515;
	this.uc = isBuild ? '88093483-da5c-44b2-a8ed-1d2413eef57a' : 'fd88e7ff-d7de-45ae-ae2a-9a77906c00d3';

	this.bindPhone = {
		// 登录方式，0：手机号，1：邮箱
		loginWay: [0]
	};

	// 显示进门App下载
	this.showAppDownload = true;

	// App下载提示语
	this.descTxt = '如需更多功能，请前往APP';
}

// 获取分享配置
Bridge.prototype.getShareData = function () {
	return {
		title: '中金公司',
		desc: '中金公司股票交易部，开创了以价值发现为核心的专业投研服务的先河。历经20多年的发展，凭借“国际视野”、“一站式服务”、 “创新产品”等独特优势和核心竞争力，在全球主要资本市场为机构客户提供跨区域、跨市场、跨品种的综合金融服务。',
		link: location.href,
		img_url: 'https://image.comein.cn/comein-files/img/default/zhongjinlogo.png'
	};
};

export default Bridge;
